<div class="modal-header">
	<h4 class="modal-title">Karten Herunterladen</h4>
	<button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
	<div *ngIf="error" class="alert alert-danger">{{ error }}</div>
	<div *ngIf="!error && estimatedAmount.length === 0" class="text-center">
		<div class="spinner-border text-primary" role="status">
			<span class="visually-hidden">Laden...</span>
		</div>
		<p class="mt-2">Berechne Download-Größe...</p>
	</div>

	<!-- Hinweis: Tiles bereits heruntergeladen -->
	<div *ngIf="tilesAlreadyComplete && !error && estimatedAmount.length > 0" class="alert alert-info mb-3">
		<i class="bi bi-info-circle me-2"></i>
		Kartenkacheln sind bereits bis Zoomstufe {{currentMaxZoom}} heruntergeladen.
		<span *ngIf="isHigherZoomSelected">
			Sie können eine höhere Zoomstufe auswählen, um detailliertere Karten herunterzuladen.
		</span>
	</div>

	<form *ngIf="!error && estimatedAmount.length > 0">
		<div class="mb-3">
			<label for="plusLevels" class="form-label">Detaillierungsgrad</label>
			<select size="3" class="form-select" id="plusLevels" [(ngModel)]="plusLevels" name="plusLevels">
				<option [ngValue]="0">
					Standard (Z:{{estimatedAmount[0].maxZoomLevel}}):
					{{estimatedAmount[0].count}} Bilder (~{{formatBytes(estimatedAmount[0].sizeEstimate)}})
				</option>
				<option *ngIf="estimatedAmount.length > 1" [ngValue]="1">
					Mehr (Z:{{estimatedAmount[1].maxZoomLevel}}):
					{{estimatedAmount[1].count}} Bilder (~{{formatBytes(estimatedAmount[1].sizeEstimate)}})
				</option>
				<option *ngIf="estimatedAmount.length > 2" [ngValue]="2">
					Detailliert (Z:{{estimatedAmount[2].maxZoomLevel}}):
					{{estimatedAmount[2].count}} Bilder (~{{formatBytes(estimatedAmount[2].sizeEstimate)}})
				</option>
			</select>
		</div>

		<!-- Checkbox zum Erzwingen des erneuten Downloads -->
		<div *ngIf="tilesAlreadyComplete" class="form-check mb-3">
			<input class="form-check-input" type="checkbox" id="forceRedownload"
				[(ngModel)]="forceRedownload" name="forceRedownload">
			<label class="form-check-label" for="forceRedownload">
				Kartenkacheln erneut herunterladen
				<small class="text-muted d-block">Vorhandene Kacheln werden überschrieben</small>
			</label>
		</div>

		<!-- Optionale Dokument-Downloads -->
		<div *ngFor="let group of documentGroups" class="form-check mb-2">
			<input class="form-check-input" type="checkbox"
				[id]="'docGroup_' + group.label"
				[(ngModel)]="downloadDocGroups[group.label]"
				[name]="'docGroup_' + group.label">
			<label class="form-check-label" [for]="'docGroup_' + group.label">
				{{ group.label }} herunterladen
				<small class="text-muted d-block">{{ group.urls.length }} Dokumente für Offline-Nutzung</small>
			</label>
		</div>
	</form>
</div>
<div class="modal-footer">
	<button ngbAutofocus type="button" class="btn btn-outline-secondary"
		[disabled]="!!error || estimatedAmount.length === 0 || (tilesAlreadyComplete && !forceRedownload && !anyDocGroupSelected)"
		(click)="onClose()">
		<i class="bi bi-download"></i>&nbsp;Herunterladen
	</button>
	<button *ngIf="tilesAlreadyComplete && !forceRedownload && !anyDocGroupSelected" type="button" class="btn btn-primary"
		(click)="onClose()">
		Überspringen
	</button>
</div>
